module.exports = __webpack_public_path__ + "static/media/STS Bin Site Entanglements - Script_1718730149414.085087cc.docx";